import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Lucide-aligned inline SVG icon paths canonical preservation forward
 * (no dependency addition for substrate-grade tier scaffold). SVG paths
 * sourced from Lucide canonical (ISC license; outline-only 1.5px stroke
 * per DD v0.1 §6.1 iconography spec).
 */
const ShieldCheckIcon = () => (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [_jsx("path", { d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" }), _jsx("path", { d: "m9 12 2 2 4-4" })] }));
const ShieldOutlineIcon = () => (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: _jsx("path", { d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" }) }));
const FlaskConicalIcon = () => (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [_jsx("path", { d: "M10 2v7.31" }), _jsx("path", { d: "M14 9.3V1.99" }), _jsx("path", { d: "M8.5 2h7" }), _jsx("path", { d: "M14 9.3a6.5 6.5 0 1 1-4 0" }), _jsx("path", { d: "M5.52 16h12.96" })] }));
function selectIcon(state) {
    switch (state) {
        case 'active':
        case 'production':
            return _jsx(ShieldCheckIcon, {});
        case 'inactive':
            return _jsx(ShieldOutlineIcon, {});
        case 'sandbox':
            return _jsx(FlaskConicalIcon, {});
    }
}
// v0 scaffold uses hardcoded labels per Mode 12 §2.10 scaffold scope-fence;
// i18n absorption substrate-state-event-paced firing post §D-ii substantive
// composition cycle canonical preservation forward. Substrate-grade tier
// presentation primitive avoids LocaleProvider context dependency at binding
// test layer.
function selectDefaultLabel(state) {
    switch (state) {
        case 'active':
            return 'Verified';
        case 'inactive':
            return 'Authority revoked';
        case 'sandbox':
            return 'Sandbox tier';
        case 'production':
            return 'Verified';
    }
}
export function AuthorityIndicator(props) {
    const { state, contextLabel, testId } = props;
    const label = contextLabel ?? selectDefaultLabel(state);
    return (_jsxs("span", { className: `authority-indicator authority-indicator--${state}`, "data-testid": testId ?? `authority-indicator-${state}`, "data-state": state, role: "status", "aria-label": label, children: [_jsx("span", { className: "authority-indicator__icon", "aria-hidden": "true", children: selectIcon(state) }), _jsx("span", { className: "authority-indicator__label", children: label })] }));
}
//# sourceMappingURL=authority-indicator.js.map